import qmath from "./qmath";

class SkRenderingContext {
	constructor() {
		this.displayItemList = [];
		this.pixelRatio = window.devicePixelRatio;

		this.globalTransformSet = {
			all: new qmath.Mat4(),
			view: new qmath.Mat4()
		};

		this.viewState = {
			viewportTransform: new qmath.Mat4(),
			viewportMoveTransform: new qmath.Mat4(),
			scaleTransform: new qmath.Mat4(),
			rotation: new qmath.Mat4(),
			pRotation: new qmath.Mat4(),
			yRotation: new qmath.Mat4(),			
			yawAngle: Math.PI * 0.25,
			pitchAngle: Math.PI * -0.25,
			viewportCenter: {x:0, y: 0}
		};
	}

	wrapAngles() {
		this.viewState.yawAngle = wrap_rad(this.viewState.yawAngle);
	}

	updateTransforms() {
		this.buildViewportTransform();
		this.buildGlobalViewTransform();

		qmath.bulkApplyMatrices(this.globalTransformSet.all, [this.globalTransformSet.view, this.viewState.viewportTransform]);
	}

	buildViewportTransform() {
		const s = this.viewState;
		s.viewportMoveTransform.translate2(s.viewportCenter.x, s.viewportCenter.y);
		s.viewportTransform.mul(s.scaleTransform, s.viewportMoveTransform);
	}

	buildGlobalViewTransform() {
		const s = this.viewState;

		s.yRotation.rotZ(s.yawAngle);
		s.pRotation.rotX(s.pitchAngle);

		qmath.bulkApplyMatrices(this.globalTransformSet.view, [
			s.yRotation,
			s.pRotation
		]);
	}

	setViewport(cx, cy, scale, pixelRatio) {
		const s = this.viewState;
		s.viewportCenter.x = cx;
		s.viewportCenter.y = cy;

		s.scaleTransform.scale2(scale * pixelRatio, -scale * pixelRatio);
	}

	clearDisplayItemList() {
		for (const d of this.displayItemList) {
			d.dispose();
		}

		this.displayItemList.length = 0;
		return this.displayItemList;
	}

	getDisplayItemList() {
		return this.displayItemList;
	}

	applyTransforms() {
		const m = this.globalTransformSet.all;
		const ls = this.displayItemList;

		// Complete the transform calculations.
		for (const d of ls) { d.processTransformTree(m); }

		// Apply for all
		for (const d of ls) { d.applyFinalTransform(m); }

		return this;
	}

	calcSortKeys() {
		const ls = this.displayItemList;
		for (const d of ls) { d.calcSortKey(); }

		return this;
	}
}

function wrap_rad(r) {
	return Math.atan2(Math.sin(r), Math.cos(r));
}

function buildDisplayList(ctx, root) {
	ctx.clearDisplayItemList();

	const bldg = root.activeBuilding;
	buildDisplayListRecursively(ctx, bldg, bldg);
}

function buildDisplayListRecursively(ctx, building, parent) {
	const dls = ctx.getDisplayItemList();
	parent.generateDisplayList(dls);

	if (parent.forEach) {
		parent.forEach(ch => {
			buildDisplayListRecursively(ctx, building, ch);
		});
	}
}

function cmp_sortKey(a, b) {
	return a.sortKey - b.sortKey;
}

function stek_render(targetCanvas, context, docRoot, pixelRatio) {
	const c_width = targetCanvas.width - 0;
	const c_height = targetCanvas.height - 0;
	const g = targetCanvas.getContext("2d");

	context.setViewport(c_width >> 1, c_height >> 1, 1, pixelRatio);
	context.updateTransforms();

	const dls = context.getDisplayItemList();
	buildDisplayList(context, docRoot);

	context.applyTransforms().calcSortKeys();
	dls.sort(cmp_sortKey);

	g.clearRect(0, 0, c_width, c_height);
	for (const d of dls) {
		d.draw(g, 1);
	}
}

export { stek_render };
export default SkRenderingContext;